export class PeriodicCacheModel{
  Id:number;
  regionName:string;
  time:string;
  day:string;
  isActive:boolean;
}
